import moment from "moment";
import "moment/locale/zh-cn";
import tim from '../../initTIM';
const tecentIm = {
    state: {
        conversationListObj: JSON.stringify({}),
        isUnread: JSON.stringify({}),
        conversationList: [],
        unreadTotal: 0,
        isLogin: false
    },
    getters: {
        timGetImIslogin: (state) => state.isLogin,
        timGetImMsgList: (state) => state.conversationList,
        timGetImTotal: (state) => state.unreadTotal,
        timGetUnreadMsg: (state) => (key) => {
            let num = 0;
            if (state.isUnread[key]) {
                num = state.isUnread[key];
            } else {
                num = 0
            }
            return num;
        },
    },

    mutations: {
        TIM_SAVE_IM_MESSAGE(state, params = { key, reset }) {
            let list = params.conversationList;
            let obj = {}
            for (let i in list) {
                if (list[i].unread) {
                    if (!obj[list[i].unread]) {
                        obj[list[i].unread] = list[i].unreadCount
                    }
                }
            }
            console.log('obj', obj)
            state.isUnread = obj
        },
        TIM_SET_LIST: (state, conversationList) => {
            state.conversationList = conversationList
        },
        TIM_SET_UNREAD_TOTAL: (state, unreadTotal) => {
            state.unreadTotal = unreadTotal
        },
        TIM_AGAIN_LOGIN: (state, flag) => {
            state.isLogin = flag
        },

    },
    actions: {
        timSaveImMessage({ commit }, option) {
            commit('TIM_SAVE_IM_MESSAGE', option);
        },
        timLoginAgain({ commit }, callback) {
            let imUserId = JSON.parse(localStorage.getItem("imUser")).imUserId;
            let promise = tim.login({
                userID: imUserId,
                userSig: localStorage.userSig,
            });
            promise
                .then(function (imResponse) {
                    commit('TIM_AGAIN_LOGIN', true);
                    if (callback) callback(imResponse)
                })
                .catch(function (imError) {
                    console.log("imError", imError);
                });

        },
        timGetConversationListHandle({ commit }, callback) {
            return new Promise((resolve, reject) => {
                let promise = tim.getConversationList();
                if (!promise) {
                    return;
                }
                promise
                    .then(function (imResponse) {
                        console.log("vuex=====>getConversationListHandle----->会话列表=====>", imResponse);
                        // 如果最后一条消息是自定义消息的话，处理一下data
                        const conversationList = imResponse.data.conversationList; // 会话列表，用该列表覆盖原有的会话列表
                        let number = 0;
                        if (conversationList.length == 0) {
                            commit('TIM_SET_LIST', conversationList);
                            commit('TIM_SET_UNREAD_TOTAL', number);
                            resolve(conversationList)
                        }
                        conversationList.forEach((e) => {
                            if (e.lastMessage.type == "TIMCustomElem") {
                                let data = e.lastMessage.payload.data;
                                let new_data = "";
                                if (typeof data == "string" && data) {
                                    new_data = JSON.parse(data);
                                }
                                e.lastMessage.payload.data = new_data;
                            }
                        });
                        conversationList.forEach((e) => {
                            number = number + e.unreadCount;
                        });
                        conversationList.map((item) => {
                            if (item.type == "GROUP") {
                                item.headimg = item.groupProfile.avatar;
                                item.userName = item.groupProfile.name;
                                item.unread = item.groupProfile.groupID;
                            }
                            if (item.type == "C2C") {
                                item.headimg = item.userProfile.avatar;
                                item.userName = item.userProfile.nick;
                                item.unread = item.userProfile.userID;
                            }
                            if (item.type == "@TIM#SYSTEM") {
                                item.headimg = "";
                            }
                            item.content = item.lastMessage.messageForShow;
                            item.createTime = moment(
                                new Date(item.lastMessage.lastTime * 1000)
                            ).format("YYYY-MM-DD HH:mm:ss");
                            item.num = item.unreadCount;
                        });
                        commit('TIM_SET_LIST', conversationList);
                        commit('TIM_SET_UNREAD_TOTAL', number);
                        commit('TIM_SAVE_IM_MESSAGE', { conversationList });
                        if (callback) {
                            callback({ conversationList, number })
                        }
                        resolve({ conversationList, number })
                    })
                    .catch(function (imError) {
                        commit('TIM_AGAIN_LOGIN', false);
                        if (callback) {
                            callback(false)
                        }
                        console.log("获取群组会话失败==----getConversationList error哎:=====>", imError); // 获取会话列表失败的相关信息
                        // reject(imError)
                        return;
                    });
            });
        },
    }
}

export default tecentIm
